export default __webpack_public_path__ + "static/media/CJ_Glass_Door_Logo_Mockup.682d448c.jpg";